import React, { useState } from 'react'

import DropdownStringOptions from 'live/components/forms/ui/dropdown/dropdown-string-options'

import { RowDiv } from './styles'

export type IClassicPaginationProps = {
    type: 'classic'
    /**
     * current Page of List
     */
    currentPage: number
    /**
     * total pages of List
     */
    totalPages: number
    /**
     * perPage is an Array of numbers that represent how much values list can show
     * the default value is always perPage[0] if perPage have only 1 item dropdown will not be render because it doesnt need
     */
    perPage: number[]
    /**
     * how Much itens have in the list
     */
    totalItens: number
    /**
     * onPageRequestClick will return the new page after user interaction
     */
    onPageRequestClick: (k: number) => void
    /**
     * onPerPageChange will return the new max itens per page on list
     */
    onPerPageChange?: (k: number) => void
}

export const ClassicPagination: React.FC<IClassicPaginationProps> = ({
    currentPage,
    perPage,
    totalItens,
    totalPages,
    onPageRequestClick,
    onPerPageChange
}) => {
    const [selectedPerPageArray, setSelectedPerPageArray] = useState(0)

    return (
        <RowDiv>
            <div className={'pagination-pages'}>
                <i
                    className="fas fa-chevron-double-left"
                    onClick={() => currentPage > 1 && onPageRequestClick(1)}
                    style={{ cursor: currentPage > 1 ? 'pointer' : 'not-allowed' }}
                />
                <i
                    className="fas fa-chevron-left"
                    onClick={() => currentPage > 1 && onPageRequestClick(currentPage - 1)}
                    style={{ cursor: currentPage > 1 ? 'pointer' : 'not-allowed' }}
                />
                {perPage[selectedPerPageArray] * (currentPage - 1) > 0
                    ? perPage[selectedPerPageArray] * (currentPage - 1)
                    : 1}{' '}
                - {perPage[selectedPerPageArray] * currentPage} de {totalItens}
                <i
                    className="fas fa-chevron-right"
                    onClick={() => totalPages > 1 && currentPage !== totalPages && onPageRequestClick(currentPage + 1)}
                    style={{ cursor: totalPages > 1 && currentPage !== totalPages ? 'pointer' : 'not-allowed' }}
                />
                <i
                    className="fas fa-chevron-double-right"
                    onClick={() => totalPages > 1 && currentPage !== totalPages && onPageRequestClick(totalPages)}
                    style={{ cursor: totalPages > 1 && currentPage !== totalPages ? 'pointer' : 'not-allowed' }}
                />
            </div>
            <div className={'pagination-perpages'}>
                {perPage.length > 1 && (
                    <DropdownStringOptions
                        options={perPage}
                        selectedOption={selectedPerPageArray}
                        onSelect={e => {
                            setSelectedPerPageArray(e)
                            onPerPageChange(perPage[e])
                        }}
                        fullWidth={false}
                        disabled={false}
                    />
                )}
            </div>
        </RowDiv>
    )
}
